import AuditorModal from "./AuditorModal";

export default AuditorModal;